import React from "react";
import { motion } from "framer-motion";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
export function FinalCTA() {
  return <section className="w-full bg-[var(--brand-dark)] px-4 py-16 text-center" data-id="element-93" data-mp="3ueqfza2e2zel">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="mx-auto max-w-lg" data-id="element-94" data-mp="c83qbmjqhq6l">
        <h2 className="font-serif-display text-2xl font-extrabold leading-tight text-white sm:text-4xl" data-id="element-95" data-mp="m3ngdsbm9unf">
          ¿Listo para dejar de improvisar y comenzar a{" "}
          <span className="italic text-[var(--cta)]" data-id="element-96" data-mp="vv9o3eoqxblf">diagnosticar con un sistema?</span>
        </h2>
        <p className="mt-4 text-sm text-white/80 sm:text-base" data-id="element-97" data-mp="qv595t3hkoxb">
          Empieza hoy mismo a planificar rehabilitaciones complejas con mayor seguridad y confianza.
        </p>

        <div className="mt-8" data-id="element-98" data-mp="zwd6o8y6hlqc">
          <CTAButton data-id="element-99" data-mp="zx4rcoq8lz1u" />
          <p className="mt-3 text-xs font-medium text-white/70" data-id="element-100" data-mp="zxy0fwco50n5">
            Solo <strong data-id="element-101" data-mp="2c5g6g6d0l2vy">USD $12.99</strong> · Descarga inmediata · Acceso de por vida · Garantía de 7 días
          </p>
        </div>

        <div className="mt-8 rounded-2xl bg-white/5 p-4" data-id="element-102" data-mp="2h49jxysawtw4">
          <div className="[&_*]:!text-white" data-id="element-103" data-mp="2m2b4ko5dl19p">
            <Countdown data-id="element-104" data-mp="2m1j695ke8pfq" />
          </div>
        </div>
      </motion.div>
    </section>;
}